import React from "react";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import useStyles from "./styles";

export interface Props {
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  children: React.ReactNode;
  title: string;
  confirmButtonText?: string;
  positive?: boolean;
}

const ConfirmationDialog = (props: Props) => {
  const {
    children,
    onCancel,
    onConfirm,
    open,
    title,
    confirmButtonText,
    positive = true
  } = props;
  const classes = useStyles();

  const handleCancel = () => {
    onCancel();
  };

  const handleDelete = () => {
    onConfirm();
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className={classes.confirmationDialog}
    >
      <DialogTitle>
        <Typography className={classes.dialogTitleTypography}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <div className={classes.dialogContentText}>{children}</div>
      </DialogContent>
      <DialogActions>
        <div className={classes.decisions}>
          <Button
            className={clsx(classes.button, classes.cancel)}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            className={clsx(classes.button, {
              [classes.discard]: !positive,
              [classes.confirm]: positive
            })}
            onClick={handleDelete}
          >
            {confirmButtonText ? confirmButtonText : "Confirm"}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
